import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogHelper, ExceptionHelper } from './../../../../helper';

import { CustomerAddService } from './customer-add.service';

@Component({
  selector: 'app-customer-add',
  templateUrl: './customer-add.component.html',
  styleUrls: ['./customer-add.component.css']
})
export class CustomerAddComponent implements OnInit {
  @ViewChild('successModal') successModal: any;

  addCustomerForm: FormGroup;

  contactEmailOne: string = '';
  contactEmailTwo: string = '';
  contactNumberOne: string = '';
  contactNumberTwo: string = '';
  contactPersonOne: string = '';
  contactPersonTwo: string = '';
  loginEmail: string = '';
  name: string = '';
  shortName: string = '';

  constructor(
    private dialog: DialogHelper,
    private exception: ExceptionHelper,
    private formBuilder: FormBuilder,
    private customerAddService: CustomerAddService,
    private router: Router,
    private translate: TranslateService
  ) {
    translate.setDefaultLang('en-us');
  }

  ngOnInit() {
    this.createAddCustomerForm();
  }

  public createAddCustomerForm(): void {
    this.addCustomerForm = this.formBuilder.group({
      contactEmailOne: new FormControl('', [
        Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'),
        Validators.maxLength(100)
      ]),
      contactEmailTwo: new FormControl('', [
        Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'),
        Validators.maxLength(100)
      ]),
      contactNumberOne: new FormControl('', [
        Validators.maxLength(100)
      ]),
      contactNumberTwo: new FormControl('', [
        Validators.maxLength(100)
      ]),
      contactPersonOne: new FormControl('', [
        Validators.maxLength(100)
      ]),
      contactPersonTwo: new FormControl('', [
        Validators.maxLength(100)
      ]),
      customerProjectContactEmailOne: new FormControl('', [
        Validators.maxLength(100),
        Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'),
      ]),
      customerProjectContactEmailTwo: new FormControl('', [
        Validators.maxLength(100),
        Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'),
      ]),      
      customerProjectContactNumberOne: new FormControl('', [
        Validators.maxLength(100)
      ]),      
      customerProjectContactNumberTwo: new FormControl('', [
        Validators.maxLength(100)
      ]),
      customerProjectContactNameOne: new FormControl('', [
        Validators.maxLength(100)
      ]),
      customerProjectContactNameTwo: new FormControl('', [
        Validators.maxLength(100)
      ]),
      loginEmail: new FormControl('', [
        Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'),
        Validators.maxLength(100)
      ]),
      name: new FormControl('', [
        Validators.required,
        Validators.maxLength(100)
      ]),
      shortName: new FormControl('', [
        Validators.required,
        Validators.maxLength(100)
      ])
    });
  }

  public addCustomer(addCustomerForm): void {

    this.customerAddService.create(addCustomerForm.controls).subscribe(
      data  => {
        if (data) {
          this.dialog.showModal('showSucModalBtn');
        }
      },
      error => {
        this.exception.showError(error, 'showDanModalBtn');
      }
    );
  }

  public closeSuccessModel(): void {
    this.router.navigate(['/home/customers']);
  }

  public continue(): void {
    this.successModal.hide();
    this.router.navigate([this.router.url]);
    this.ngOnInit();
  }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/customer/customer-add/customer-add.component.ts